@let searchTemplate = fullSearchOverlay.template$ | async;
@let dockedSearch = !!searchTemplate && isDesktopViewport() && !isNativePlatform;
<ion-split-pane contentId="main-content"
  [when]="(dockedSearch || desktopNavigationExpanded) ? '(min-width: 992px)' : false" class="app-shell">
  <ion-menu
    id="main-navigation"
    menuId="main-menu"
    side="start"
    type="overlay"
    [swipeGesture]="!modalStack.popupActive()"
    (ionWillOpen)="mainMenuOpen = true"
    (ionDidClose)="mainMenuOpen = false"
    [disabled]="!dockedSearch && isDesktopViewport() && !desktopNavigationExpanded"
    [maxEdgeStart]="menuMaxEdgeStart"
    contentId="route-content"
    class="app-shell__menu">
    @if (dockedSearch) {
      <div class="app-shell__search-sidebar" [hidden]="fullSearchOverlay.navigationVisible">
        <ng-container *ngTemplateOutlet="searchTemplate; context: {docked: true}"></ng-container>
      </div>
    }
    @if (!dockedSearch || fullSearchOverlay.navigationVisible) {
    <sm-nav-bar
      [profile]="navProfile"
      [items]="navItems"
      [selectedId]="selectedNavId"
      [preferenceAccountId]="navPreferenceAccountId"
      [footerActionText]="footerActionText"
      (itemSelected)="handleNavItemSelected($event)"
      (footerActionClick)="handleFooterActionClick()">
    </sm-nav-bar>
    }
  </ion-menu>

  <main id="main-content" class="app-shell__content" #shellContent>
    <header class="app-shell__topbar">
      <div class="app-shell__brand-area">
        <button type="button" class="app-shell__desktop-trigger"
          aria-controls="main-navigation"
          [attr.aria-expanded]="dockedSearch ? fullSearchOverlay.navigationVisible : desktopNavigationExpanded"
          [attr.aria-label]="((dockedSearch ? fullSearchOverlay.navigationVisible : desktopNavigationExpanded) ? 'shell.nav.hideNavigation' : 'shell.nav.showNavigation') | translate"
          (click)="toggleDesktopNavigation(dockedSearch)">
          <ion-icon name="menu-outline" aria-hidden="true"></ion-icon>
        </button>
        <div class="app-shell__mobile-trigger">
          <ion-menu-button menu="main-menu" autoHide="false"
            [attr.aria-label]="'shell.nav.mainMenuAriaLabel' | translate"></ion-menu-button>
        </div>

        <div class="app-shell__brand">
          <img class="app-shell__brand-mark" src="/assets/brand/invemory-container-memory-mark.png" alt="" aria-hidden="true"/>
          <span class="app-shell__brand-text">{{ applicationIdentityService.appDisplayName() }}</span>
        </div>
      </div>

      <div class="app-shell__toolbar">
        <div class="app-shell__search-stack" #searchStack>
          <sm-search-control
            class="app-shell__search-control"
            [value]="searchQuery"
            [scannedType]="searchScan?.type ?? null"
            [scannedTypeLabel]="(searchScan?.type === 'qr' ? 'universalScan.qr' : 'barcode.label') | translate"
            [placeholder]="searchPlaceholder"
            [searchAriaLabel]="searchAriaLabel"
            [searchModeAriaLabel]="searchFiltersAriaLabel"
            [scanAriaLabel]="'universalScan.scan' | translate"
            [selectedModeId]="selectedSearchModeId"
            [modeItems]="searchModeItems"
            [modeSelectionStyle]="'radio'"
            (valueChange)="handleSearchQueryChange($event)"
            (compositionStarted)="handleSearchResultsClose()"
            (searchRequested)="handleSearchSubmit()"
            (selectedModeIdChange)="handleSearchModeChange($event)"
            (scanClick)="handleSearchScanClick()">
          </sm-search-control>

          <sm-global-search-results
            class="app-shell__search-results" [showTagAuthors]="true" [tagSelection]="searchTagSelection" (tagSelectionChange)="selectSearchTagAuthors($event)"
            [style.--app-shell-search-results-left.px]="searchResultsLeft"
            [style.--app-shell-search-results-width.px]="searchResultsWidth"
            [style.--app-shell-search-results-top.px]="searchResultsTop"
            [style.--app-shell-search-results-viewport-top.px]="searchResultsViewportTop"
            [isOpen]="searchResultsOpen"
            [fullSearchLabel]="'fullSearch.goToSearch' | translate"
            (fullSearchRequested)="openFullSearch()"
            [query]="searchQuery"
            [highlightQuery]="searchQuery"
            [isLoading]="searchResultsLoading"
            [error]="searchResultsError"
            [title]="searchResultsTitle"
            [closeLabel]="searchResultsCloseLabel"
            [loadingLabel]="searchResultsLoadingLabel"
            [limitLabel]="searchResultsLimitLabel"
            [emptyTitle]="searchResultsEmptyTitle"
            [emptyDescriptionTemplate]="searchResultsEmptyDescriptionTemplate"
            [errorPrefix]="searchResultsErrorPrefix"
            [containersTitle]="searchResultsContainersTitle"
            [itemsTitle]="searchResultsItemsTitle"
            [containers]="searchResults.containers"
            [hasMoreContainers]="searchResults.hasMoreContainers"
            [hasMoreItems]="searchResults.hasMoreItems"
            [items]="searchResults.items"
            [containerMenuItems]="searchResultsContainerMenuItems"
            [itemMenuItems]="searchResultsItemMenuItems"
            [containerEmptyDescriptionLabel]="searchResultsContainerEmptyDescriptionLabel"
            [itemEmptyDescriptionLabel]="searchResultsItemEmptyDescriptionLabel"
            [containerMenuAriaLabelTemplate]="searchResultsContainerMenuAriaLabelTemplate"
            [itemMenuAriaLabelTemplate]="searchResultsItemMenuAriaLabelTemplate"
            [rootLocationLabel]="searchResultsRootLocationLabel"
            (closeRequested)="handleSearchResultsClose()"
            (containerOpen)="handleSearchContainerOpen($event)"
            (itemOpen)="handleSearchItemOpen($event)"
            (containerMenuItemSelect)="handleSearchContainerMenuItemSelect($event)"
            (itemMenuItemSelect)="handleSearchItemMenuItemSelect($event)">
          </sm-global-search-results>
        </div>

      </div>
    </header>

    <div class="app-shell__page">
      @if (!isAboutRoute) {
        <app-shell-breadcrumbs
          [breadcrumbs]="breadcrumbs"
          [ariaLabel]="breadcrumbAriaLabel"
          [compactMode]="isCompactViewport()"
          [collapsed]="breadcrumbsCollapsed"
          [relocationMode]="activeRelocationDragState !== null"
          [relocationSourceKind]="activeRelocationDragState?.source?.kind ?? null"
          [relocationSourceId]="activeRelocationDragState?.source?.id ?? ''"
          [iconResolver]="resolveBreadcrumbIcon"
          [expandLabel]="breadcrumbExpandLabel"
          [fullPathLabel]="breadcrumbFullPathLabel"
          [routeHrefBuilder]="getBreadcrumbHref"
          [trailingActionTemplate]="breadcrumbTrailingActionTemplate"
          (breadcrumbSelected)="navigateToBreadcrumb($event)"
          (breadcrumbLongPressed)="handleBreadcrumbLongPress($event)"
          (fullPathOpened)="handleFullPathOpened()"
          (fullPathClosed)="handleFullPathClosed()">
        </app-shell-breadcrumbs>

        <sm-global-search-results
          class="app-shell-sibling-switcher-results"
          [style.left.px]="siblingSwitcherPanelLeft"
          [style.top.px]="siblingSwitcherPanelTop"
          [style.width.px]="siblingSwitcherPanelWidth"
          [style.--sm-global-search-results-max-height]="'calc(100vh - ' + siblingSwitcherPanelTop + 'px - 8px)'"
          [isOpen]="siblingSwitcherOpen"
          [query]="siblingSwitcherCurrentContainerName"
          [isLoading]="siblingSwitcherLoading"
          [error]="siblingSwitcherError"
          [title]="siblingSwitcherRelocationMode ? siblingSwitcherRelocationTitle : siblingSwitcherTitle"
          [closeLabel]="searchResultsCloseLabel"
          [backLabel]="siblingSwitcherPathReturn ? breadcrumbBackToPathLabel : ''"
          [loadingLabel]="siblingSwitcherLoadingLabel"
          [retryLabel]="siblingSwitcherRetryLabel"
          [emptyTitle]="siblingSwitcherEmptyLabel"
          emptyDescriptionTemplate=""
          errorPrefix=""
          [containersTitle]="searchResultsContainersTitle"
          [itemsTitle]="searchResultsItemsTitle"
          [containers]="siblingSwitcherResults"
          [items]="[]"
          [containerInventoryMenuSource]="siblingSwitcherRelocationMode ? null : 'containers'"
          [containerMenuItems]="[]"
          [relocationMode]="siblingSwitcherRelocationMode"
          [relocationSourceKind]="siblingSwitcherRelocationSourceKind"
          [relocationSourceId]="siblingSwitcherRelocationSourceId"
          [containerCurrentLabel]="siblingSwitcherCurrentLabel"
          [containerEmptyDescriptionLabel]="searchResultsContainerEmptyDescriptionLabel"
          [containerMenuAriaLabelTemplate]="searchResultsContainerMenuAriaLabelTemplate"
          [rootLocationLabel]="searchResultsRootLocationLabel"
          (closeRequested)="handleSiblingSwitcherCloseRequested()"
          (backRequested)="handleSiblingSwitcherBackToPath()"
          (retryRequested)="retrySiblingSwitcher()"
          (containerOpen)="handleSiblingContainerOpen($event)"
          (containerMenuItemSelect)="handleSiblingContainerMenuItemSelect($event)">
        </sm-global-search-results>
      }

      <ion-content
        id="route-content"
        class="app-shell__route-content"
        [scrollY]="true"
        [scrollEvents]="true"
        [forceOverscroll]="true"
        (ionScroll)="handleRouteScroll($event)">
        <ion-refresher
          slot="fixed"
          [disabled]="routeRefreshDisabled"
          (ionRefresh)="handleRouteRefresh($event)">
          <ion-refresher-content></ion-refresher-content>
        </ion-refresher>

        <router-outlet></router-outlet>
      </ion-content>
    </div>

    @if (editorActions.template$ | async; as editorActionsTemplate) {
      <div class="app-shell__editor-actions">
        <ng-container [ngTemplateOutlet]="editorActionsTemplate"></ng-container>
      </div>
    } @else if (!isAboutRoute) {
      <footer
        class="app-shell__status-bar"
        [attr.aria-label]="statusBarAriaLabel">
        <div class="app-shell__status-copy">
          <p>
            <sm-policy-link
              class="app-shell__status-link"
              [href]="websiteRootHref"
              [externalHref]="websiteExternalHref"
              [openInExternalBrowser]="true"
              purpose="commercial"
              [ariaLabel]="applicationIdentityService.appDisplayName()">
              <span aria-hidden="true">©</span>
              <span class="app-shell__status-label">{{ applicationIdentityService.appDisplayName() }}</span>
            </sm-policy-link>
          </p>
          <sm-app-version/>
        </div>

        @if (buildMarkerLabel) {
          <span class="app-shell__build-marker">{{ buildMarkerLabel }}</span>
        }
      </footer>
    }

    @if (!dockedSearch) {
      <ng-container *ngTemplateOutlet="searchTemplate; context: {$implicit: searchScannerOpen || searchResultsOpen || siblingSwitcherOpen}"></ng-container>
    }
    <sm-quick-navigation
      [accountId]="navPreferenceAccountId" [items]="quickNavItems" [selectedId]="selectedNavId"
      [blocked]="mainMenuOpen || searchScannerOpen || searchResultsOpen || siblingSwitcherOpen">
    </sm-quick-navigation>

    <sm-universal-scanner [isOpen]="searchScannerOpen"
      (closeRequested)="handleSearchScannerClose()" (scanned)="handleSearchScannerDetected($event)">
    </sm-universal-scanner>
  </main>
</ion-split-pane>
